export default __webpack_public_path__ + "static/media/Frame 10825_1.cd767bc2.svg";